import { render, staticRenderFns } from "./TissSubTitle.vue?vue&type=template&id=2fa7fafa&"
import script from "./TissSubTitle.vue?vue&type=script&lang=js&"
export * from "./TissSubTitle.vue?vue&type=script&lang=js&"
import style0 from "./TissSubTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports